import React from 'react';
/**
 * Hook to track whether a scrollable modal slideout is scrolled to the top.
 *
 * @returns {{
 *   isScrolledToTop: boolean;
 *   handleScroll: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void;
 *   handleResetScroll: () => void;
 * }} Scroll state and handlers for scrollable modal content.
 */
export const useModalSlideoutScroll = () => {
    const [isScrolledToTop, setIsScrolledToTop] = React.useState(() => true);
    const handleScroll = React.useCallback((e) => {
        const fromTop = 16;
        if (e.currentTarget.scrollTop < fromTop && !isScrolledToTop) {
            setIsScrolledToTop(true);
        }
        else if (e.currentTarget.scrollTop >= fromTop && isScrolledToTop) {
            setIsScrolledToTop(false);
        }
    }, [isScrolledToTop]);
    const handleResetScroll = () => setIsScrolledToTop(true);
    return { isScrolledToTop, handleScroll, handleResetScroll };
};
